import { createContext, useContext, useMemo, useState } from 'react';

type Props = {
  children?: React.ReactNode;
};

interface HeaderTextType {
  headerText: string;
  setHeaderText: (headerText: string) => void;
}

const headerTextContext = createContext({} as HeaderTextType);

export const HeaderTextProvider: React.FC<Props> = ({ children }) => {
  const [headerText, setHeaderText] = useState('');

  const value = useMemo(() => ({ headerText, setHeaderText }), [headerText]);

  return <headerTextContext.Provider value={value}> {children} </headerTextContext.Provider>;
};

export const useHeaderText = () => useContext(headerTextContext);
